import { useContext, useEffect, useState } from "react";
import { postData } from "../helpers/dataSending";
import { sendInquiryDataInRedirect } from "../components/sendInquiry";
import { CompareProductMethodsProps } from "../models/comapreResults";
import { scrollToRef } from "../helpers/scrollToRef";
import { StaticSettingsAppContext } from "../modules/App/App";

interface CTAButtonsProps extends CompareProductMethodsProps {
  api: {
    compareUrl: string;
    inquiryUrl: string;
  };
  dictionary: {
    makeInquiryText: string;
    compareText: string;
  };
  data: {
    dataForCompare: string[];
    dataForInquiry: string[];
    compareProductsLength: number;
  };
}

export const CTAButtons = (props: CTAButtonsProps) => {
  const STATIC_SETTINGS_APP = useContext(StaticSettingsAppContext);
  const [disabledButtonCompare, setDisabledButtonCompare] = useState(true);
  const scrollToTopApp = scrollToRef(STATIC_SETTINGS_APP.APP_REF);

  useEffect(() => {
    const disabledButton = !(props.data.compareProductsLength > 1);
    setDisabledButtonCompare(disabledButton);
  }, [props.data.compareProductsLength]);

  // Function for sending data to compare
  function sendComparisonData() {
    if (props.data.dataForCompare.length > 0) {
      const dataForComparison = {
        IdList: props.data.dataForCompare,
      };
      postData(props.api.compareUrl, dataForComparison, "POST", "compareData")
        .then((result) => {
          props.setCompareResults({ view: true, results: result });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          scrollToTopApp();
        });
    }
  }

  return (
    <div className="CTA-holder">
      <button
        className="no-button"
        onClick={sendComparisonData}
        disabled={disabledButtonCompare}
      >
        {props.dictionary.compareText}
      </button>
      <button
        className="button"
        onClick={() => {
          sendInquiryDataInRedirect({
            dataForInquiry: props.data.dataForInquiry,
            inquiryUrl: props.api.inquiryUrl,
          });
        }}
      >
        {props.dictionary.makeInquiryText}
      </button>
    </div>
  );
};
